import { defineComponent as d, openBlock as a, createElementBlock as o, mergeProps as p, unref as e, renderSlot as i, createElementVNode as n, createCommentVNode as m } from "vue";
import { useScalarIcon as u } from "../hooks/useScalarIcon.js";
const A = { key: 0 }, Z = { key: 1 }, g = { key: 2 }, M = { key: 3 }, f = { key: 4 }, k = { key: 5 }, h = {
  name: "ScalarIconCards"
}, _ = /* @__PURE__ */ d({
  ...h,
  props: {
    label: {},
    weight: {}
  },
  setup(H) {
    const V = H, { bind: r, weight: l } = u(V);
    return (s, t) => (a(), o("svg", p({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(r)), [
      i(s.$slots, "default"),
      e(l) === "bold" ? (a(), o("g", A, t[0] || (t[0] = [
        n("path", { d: "M180,72H36A20,20,0,0,0,16,92V204a20,20,0,0,0,20,20H180a20,20,0,0,0,20-20V92A20,20,0,0,0,180,72Zm-4,128H40V96H176ZM240,52V176a12,12,0,0,1-24,0V56H64a12,12,0,0,1,0-24H220A20,20,0,0,1,240,52Z" }, null, -1)
      ]))) : e(l) === "duotone" ? (a(), o("g", Z, t[1] || (t[1] = [
        n("path", {
          d: "M192,88V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8H184A8,8,0,0,1,192,88Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M184,72H40A16,16,0,0,0,24,88V200a16,16,0,0,0,16,16H184a16,16,0,0,0,16-16V88A16,16,0,0,0,184,72Zm0,128H40V88H184V200ZM232,56V176a8,8,0,0,1-16,0V56H64a8,8,0,0,1,0-16H216A16,16,0,0,1,232,56Z" }, null, -1)
      ]))) : e(l) === "fill" ? (a(), o("g", g, t[2] || (t[2] = [
        n("path", { d: "M200,88V200a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V88A16,16,0,0,1,40,72H184A16,16,0,0,1,200,88Zm16-48H64a8,8,0,0,0,0,16H216V176a8,8,0,0,0,16,0V56A16,16,0,0,0,216,40Z" }, null, -1)
      ]))) : e(l) === "light" ? (a(), o("g", M, t[3] || (t[3] = [
        n("path", { d: "M184,74H40A14,14,0,0,0,26,88V200a14,14,0,0,0,14,14H184a14,14,0,0,0,14-14V88A14,14,0,0,0,184,74Zm2,126a2,2,0,0,1-2,2H40a2,2,0,0,1-2-2V88a2,2,0,0,1,2-2H184a2,2,0,0,1,2,2ZM230,56V176a6,6,0,0,1-12,0V56a2,2,0,0,0-2-2H64a6,6,0,0,1,0-12H216A14,14,0,0,1,230,56Z" }, null, -1)
      ]))) : e(l) === "regular" ? (a(), o("g", f, t[4] || (t[4] = [
        n("path", { d: "M184,72H40A16,16,0,0,0,24,88V200a16,16,0,0,0,16,16H184a16,16,0,0,0,16-16V88A16,16,0,0,0,184,72Zm0,128H40V88H184V200ZM232,56V176a8,8,0,0,1-16,0V56H64a8,8,0,0,1,0-16H216A16,16,0,0,1,232,56Z" }, null, -1)
      ]))) : e(l) === "thin" ? (a(), o("g", k, t[5] || (t[5] = [
        n("path", { d: "M184,76H40A12,12,0,0,0,28,88V200a12,12,0,0,0,12,12H184a12,12,0,0,0,12-12V88A12,12,0,0,0,184,76Zm4,124a4,4,0,0,1-4,4H40a4,4,0,0,1-4-4V88a4,4,0,0,1,4-4H184a4,4,0,0,1,4,4ZM228,56V176a4,4,0,0,1-8,0V56a4,4,0,0,0-4-4H64a4,4,0,0,1,0-8H216A12,12,0,0,1,228,56Z" }, null, -1)
      ]))) : m("", !0)
    ], 16));
  }
});
export {
  _ as default
};
